import { Select } from "../../ui/Select"
import React from "react"

export const SelectManager = React.memo(({label, name, value, onChange, required, disabled, isReport}) => {

    if (isReport) {
        return (
           <p>{label}{required && "*"}: {value}</p>
        )
    }

    return (
        <div className="form-group">
            <Select
                label={label}
                name={name}
                required={required}
                value={value}
                onChange={onChange}
                disabled={disabled}
                options={[
                    "General Partner",
                    "Managing Director",
                    "Director",
                    "Senior Manager",
                    "Partner",
                    "LLP Designated Member",
                    "Chief Executive Officer",
                    "Company Secretary",
                    "Other"
                ].map((value)=>({ value: value, display_value: value }))}
            />
        </div>
    )
})